// extracted by mini-css-extract-plugin
export default {"container":"BoxLinker_container__58Yc-","title":"BoxLinker_title__SH+y6","child":"BoxLinker_child__M37CS","connector":"BoxLinker_connector__XyM6x"};